enum BankAccountTypeEnum {
    NATIONAL = "NATIONAL",
    IBAN = "IBAN",
}

export default BankAccountTypeEnum;
